import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full space-y-5" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-4 rounded-[1.4rem] border border-[#d8e4f0] bg-white p-5 sm:p-6 shadow-[0_10px_22px_rgba(15,23,42,0.04)] sm:flex-row sm:items-center sm:justify-between"
}
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#eaf3fb] text-lg font-black text-[#2f6fab]" }
const _hoisted_5 = { class: "flex items-center gap-2.5 flex-wrap" }
const _hoisted_6 = { class: "text-[1.4rem] font-black text-[#0f172a]" }
const _hoisted_7 = { class: "inline-flex rounded-full bg-[#eaf3fb] px-3 py-1 text-[0.72rem] font-extrabold uppercase tracking-[0.08em] text-[#2f6fab]" }
const _hoisted_8 = { class: "flex flex-col sm:items-end gap-2 shrink-0" }
const _hoisted_9 = { class: "text-[0.92rem] font-extrabold text-[#0f172a]" }
const _hoisted_10 = { class: "h-2.5 w-44 rounded-full bg-[#e2e8f0] overflow-hidden" }
const _hoisted_11 = { class: "space-y-4" }
const _hoisted_12 = {
  key: 1,
  class: "rounded-[1.4rem] border border-dashed border-[#d8e4f0] bg-white p-8 text-center text-[0.92rem] text-[#64748b]"
}

import { computed } from "vue";
import AnimatedList from "@/components/AnimatedList.vue";
import AnimatedItem from "@/components/AnimatedItem.vue";
import MonthlyReportCard from "@/components/reports/MonthlyReportCard.vue";
import type {
  ReportClientCard,
  ReportMonthSlot,
  ReportStatusMeta,
} from "@/types/reports";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientReportsView',
  props: {
    client: {},
    slots: {},
    statusMeta: { type: Function },
    canView: { type: Boolean },
    canDownload: { type: Boolean }
  },
  emits: ["view-report", "download-pdf"],
  setup(__props: any) {

const props = __props;



const clientInitials = computed(() => {
  const name = props.client?.company_name?.trim();
  if (!name) return "CL";
  const words = name.split(/\s+/).filter(Boolean);
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  const stopWords = new Set(["the", "of", "and", "for", "in", "to", "a", "an"]);
  const significant = words.filter((w) => !stopWords.has(w.toLowerCase()));
  if (significant.length >= 2) {
    return (significant[0][0] + significant[1][0]).toUpperCase();
  }
  return (words[0][0] + words[1][0]).toUpperCase();
});

const generatedCount = computed(() => {
  return props.slots.filter((slot) => {
    const s = String(slot.report?.status || slot.status).toLowerCase();
    return s === "generated" || s === "published";
  }).length;
});

const totalSlots = computed(() => Math.max(props.slots.length, 1));

const progressPercentage = computed(() => {
  return Math.min(100, Math.round((generatedCount.value / totalSlots.value) * 100));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.client)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(clientInitials.value), 1),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", _hoisted_6, _toDisplayString(__props.client.company_name), 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(__props.client.client_id), 1)
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mt-1 text-[0.9rem] font-medium text-[#64748b]" }, " Monthly performance reports ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(generatedCount.value) + " of " + _toDisplayString(totalSlots.value) + " ready ", 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "h-full rounded-full bg-[#173b5f] transition-all duration-500",
                style: _normalizeStyle({ width: progressPercentage.value + '%' })
              }, null, 4)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_11, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "text-[1.25rem] font-extrabold text-[#0f172a]" }, " Monthly reports "),
        _createElementVNode("p", { class: "text-[0.9rem] text-[#64748b]" }, " One report for each month. ")
      ], -1)),
      (__props.slots.length)
        ? (_openBlock(), _createBlock(AnimatedList, {
            key: 0,
            class: "space-y-3"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slots, (slot) => {
                return (_openBlock(), _createBlock(AnimatedItem, {
                  key: slot.month_number
                }, {
                  default: _withCtx(() => [
                    _createVNode(MonthlyReportCard, {
                      "month-slot": slot,
                      "can-generate": false,
                      "can-view": Boolean(props.canView),
                      "can-download": Boolean(props.canDownload),
                      "show-html-actions": false,
                      "empty-message": 'Report is not ready yet.',
                      "status-meta": __props.statusMeta(slot),
                      "is-custom": slot.month_number > 3,
                      onView: ($event: any) => (_ctx.$emit('view-report', slot.report?.id || null)),
                      onDownloadPdf: ($event: any) => (_ctx.$emit('download-pdf', slot.report?.id || null))
                    }, null, 8, ["month-slot", "can-view", "can-download", "status-meta", "is-custom", "onView", "onDownloadPdf"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, " No monthly reports are available yet. "))
    ])
  ]))
}
}

})